export enum InvoiceStatus {
  DRAFT = 'Draft',
  PENDING_REVIEW = 'Pending Review',
  SENT = 'Sent',
  FAILED = 'Failed',
  VIEWED = 'Viewed',
  DELETED = 'Deleted',
  VOIDED = 'Voided'
}
